module.exports = __webpack_public_path__ + "static/img/bottom-button-2.83b706e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/bottom-button-2.png
// module id = hZh0
// module chunks = 1